import { Typography, Button } from '@material-ui/core';
import classNames from 'classnames';
import { useState, useEffect } from 'react';

import useStyles from '@components/common/alert-popup/styles';
import { useGlobalResize } from '@hooks/event-hooks';

const SET_TIME_OUT_DELAY = 500;
const WINDOW_WIDTH_TABLET = 600;
const WINDOW_WIDTH_LAPTOP = 960;

interface Props {
  button?: JSX.Element;
  classWrapper?: string;
  description: JSX.Element | string;
  disableBoxShadow?: true;
  errorPopup?: true;
  fixedOnTablet?: true;
  icon: 'information' | 'pen' | 'lock';
  iconClass?: string;
  staticPopup?: true;
  title?: string;
  warningPopup?: true;
  onClosed?(): void;
}

const AlertPopup: React.FC<Props> = (props) => {
  const {
    icon,
    title,
    description,
    classWrapper,
    fixedOnTablet,
    staticPopup,
    errorPopup,
    warningPopup,
    disableBoxShadow,
    iconClass,
    button,
    onClosed,
  } = props;

  const [windowWidth, setWindowWidth] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (!windowWidth) setWindowWidth(window.innerWidth);

    if (showPopup) return;

    if (
      fixedOnTablet
        ? window.innerWidth >= WINDOW_WIDTH_TABLET
        : window.innerWidth >= WINDOW_WIDTH_LAPTOP
    ) {
      setTimeout(() => {
        setShowPopup(true);
      }, SET_TIME_OUT_DELAY);
    } else if (window.innerWidth < WINDOW_WIDTH_TABLET) {
      setShowPopup(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowWidth, fixedOnTablet]);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useGlobalResize(handleResize);

  const popup = (
    <section
      className={classNames(classes.popup, classWrapper, {
        [classes.showPopup]: !staticPopup && showPopup,
        [classes.fixedPopup]: !staticPopup && fixedOnTablet,
        [classes.showFixedPopup]: !staticPopup && fixedOnTablet && showPopup,
        [classes.staticPopup]: staticPopup,
        [classes.error]: errorPopup,
        [classes.warning]: warningPopup,
        [classes.disableBoxShadow]: disableBoxShadow,
      })}
    >
      <div
        className={classNames(classes.icon, iconClass, {
          [classes.error]: errorPopup,
          [classes.warning]: warningPopup,
        })}
      >
        <i className={`icon-${icon}`} />
      </div>
      {title && (
        <Typography variant="subtitle1" className={classes.title}>
          {title}
        </Typography>
      )}
      <Typography variant="body2" className={classes.description}>
        {description}
      </Typography>
      {!staticPopup && (
        <Button
          id="close-button-alert-popup"
          variant="contained"
          className={classes.button}
          onClick={() => {
            setShowPopup(false);

            setTimeout(() => {
              onClosed?.();
            }, SET_TIME_OUT_DELAY);
          }}
        >
          Got it!
        </Button>
      )}
      {button}
    </section>
  );

  return (
    <>
      {!staticPopup && !showPopup && (
        <button
          id="open-button-alert-popup"
          className={classNames(
            classes.icon,
            classes.openPopupBtn,
            classes.border,
            {
              [classes.disableOnTabled]: fixedOnTablet,
            },
          )}
          type="button"
          onClick={() => setShowPopup(true)}
        >
          <i className={`icon-${icon}`} />
        </button>
      )}
      {popup}
    </>
  );
};

export default AlertPopup;
